<div class="space-y-4">
    <!-- Tipo de Movimiento -->
    <div class="grid grid-cols-3 gap-2 mb-2">
        @for (t of types; track t.value) {
        <button (click)="onTypeChange(t.value)"
            class="flex flex-col items-center gap-1.5 p-3 rounded-xl border-2 transition-all"
            [ngClass]="type() === t.value ? 'bg-primary/5 border-primary text-primary shadow-sm' : 'bg-white border-foreground/[0.05] text-slate-400 hover:border-slate-300'">
            <iconify-icon
                [icon]="t.value === 'IN' ? 'mdi:tray-arrow-down' : t.value === 'OUT' ? 'mdi:tray-arrow-up' : 'mdi:swap-vertical'"
                width="20"></iconify-icon>
            <span class="text-[9px] font-black uppercase tracking-tighter leading-none">{{ t.label.split(' ')[0]
                }}</span>
        </button>
        }
    </div>

    <!-- Formulario -->
    <div class="space-y-4">
        <!-- Sección de Proveedor y Factura (Solo para ENTRADAS) -->
        @if (type() === 'IN') {
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 ">
                <div class="col-span-2 space-y-1">
                    <div class="flex items-center justify-between px-1">
                        <label class="text-[10px] font-black uppercase text-slate-400 tracking-wider">Proveedor</label>
                        <button (click)="openSupplierForm()"
                            class="text-[10px] font-bold text-primary hover:underline flex items-center gap-1">
                            <iconify-icon icon="mdi:plus-circle-outline"></iconify-icon> Nuevo
                        </button>
                    </div>
                    <select [ngModel]="supplierId()" (ngModelChange)="supplierId.set($event)"
                        class="w-full h-11 px-4 rounded-xl border border-foreground/[0.05] bg-white text-sm focus:ring-2 focus:ring-primary/20 outline-none transition-all font-bold">
                        <option value="">-- Consumidor Final / Genérico --</option>
                        @for (s of suppliers(); track s._id) {
                        <option [value]="s._id">{{ s.name }} ({{ s.taxId || 'Sin RUC' }})</option>
                        }
                    </select>
                </div>

                <app-input label="Lote / Referencia" [(ngModel)]="lotNumber" icon="mdi:barcode-scan"
                    placeholder="Vacío para auto-generar"></app-input>
                <app-input label="Fecha Vencimiento" type="date" [(ngModel)]="expiryDate"
                    icon="mdi:calendar-clock"></app-input>
                
                <div class="col-span-2 grid grid-cols-2 gap-4">
                    <app-input label="Costo Unit. (Inc. IVA)" type="number" [(ngModel)]="purchasePrice" 
                        icon="mdi:currency-usd" placeholder="Opcional (0.00)"></app-input>
                    <app-input label="Nº Factura / Documento" [(ngModel)]="invoiceNumber" icon="mdi:file-document-outline"
                        placeholder="Ej: F001-000123"></app-input>
                </div>
            </div>
        } @else {
            <!-- Selección de Lote para SALIDAS / AJUSTES -->
            <div class="space-y-3 bg-slate-50 dark:bg-slate-800/50 p-4 rounded-2xl border border-slate-100 dark:border-slate-800">
                <div class="flex items-center justify-between px-1">
                    <label class="text-[10px] font-black uppercase text-slate-400 tracking-wider">
                        {{ type() === 'OUT' ? 'Gestión de Salida' : 'Seleccionar Lote a Ajustar' }}
                    </label>
                    
                    <!-- Toggle de Auto-descuento (Solo para OUT) -->
                    @if (type() === 'OUT') {
                        <button (click)="isAutoDeduct.set(!isAutoDeduct())" 
                            class="flex items-center gap-2 px-2 py-1 rounded-lg transition-all"
                            [class]="isAutoDeduct() ? 'bg-primary/10 text-primary' : 'bg-slate-200 text-slate-500'">
                            <iconify-icon [icon]="isAutoDeduct() ? 'solar:magic-stick-bold-duotone' : 'solar:hand-shake-bold-duotone'"></iconify-icon>
                            <span class="text-[9px] font-black uppercase tracking-tighter">
                                {{ isAutoDeduct() ? 'Auto (FEFO)' : 'Manual' }}
                            </span>
                        </button>
                    }
                </div>
                
                @if (type() === 'OUT' && isAutoDeduct()) {
                    <!-- Modo Auto-descuento -->
                    <div class="py-6 px-4 text-center border-2 border-dashed border-primary/20 rounded-xl bg-primary/[0.02]">
                        <iconify-icon icon="solar:magic-stick-bold-duotone" width="32" class="text-primary/40"></iconify-icon>
                        <p class="text-[11px] font-bold text-slate-600 dark:text-slate-300 mt-2">Descuento Inteligente Activado</p>
                        <p class="text-[9px] text-slate-400 uppercase font-medium mt-1 tracking-tight">
                            Se utilizarán primero los lotes con vencimiento más próximo.<br>
                            Ideal para salidas múltiples.
                        </p>
                    </div>
                } @else {
                    <!-- Selector de Lote (Manual o para Ajuste) -->
                    
                    <!-- Buscador de Lote -->
                    @if (availableLots().length > 5) {
                        <div class="relative group">
                            <iconify-icon icon="solar:magnifer-linear" class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-primary transition-colors"></iconify-icon>
                            <input type="text" [ngModel]="lotSearchTerm()" (ngModelChange)="lotSearchTerm.set($event)"
                                placeholder="Buscar por lote o fecha..."
                                class="w-full h-9 pl-9 pr-4 rounded-lg border border-foreground/[0.05] bg-white dark:bg-slate-900 text-[11px] font-medium outline-none focus:ring-2 focus:ring-primary/20 transition-all">
                        </div>
                    }

                    <div class="flex flex-col gap-2 max-h-[220px] overflow-y-auto pr-1 custom-scrollbar">
                        @if (availableLots().length === 0) {
                            <div class="py-4 text-center">
                                <iconify-icon icon="solar:info-circle-bold-duotone" width="24" class="text-slate-300"></iconify-icon>
                                <p class="text-[10px] font-bold text-slate-400 uppercase mt-1">No hay stock disponible</p>
                            </div>
                        } @else if (filteredLots().length === 0) {
                            <div class="py-4 text-center">
                                <p class="text-[10px] font-bold text-slate-400 uppercase italic">Sin resultados para "{{ lotSearchTerm() }}"</p>
                            </div>
                        } @else {
                            <div class="grid grid-cols-1 gap-2">
                                @for (lot of filteredLots(); track lot._id) {
                                    <button (click)="onLotSelect(lot)"
                                        class="text-left p-2.5 rounded-xl border border-foreground/[0.05] bg-white dark:bg-slate-900 transition-all hover:border-primary/30"
                                        [class.ring-2]="selectedLot()?._id === lot._id"
                                        [class.ring-primary]="selectedLot()?._id === lot._id">
                                        <div class="flex justify-between items-start">
                                            <div class="flex flex-col">
                                                <span class="text-[11px] font-black" [class]="selectedLot()?._id === lot._id ? 'text-primary' : 'text-slate-700 dark:text-slate-200'">{{ lot.lotNumber || 'SIN LOTE' }}</span>
                                                <span class="text-[9px] font-bold text-slate-400 uppercase">Vence: {{ lot.expiryDate | date:'dd/MM/yyyy' }}</span>
                                            </div>
                                            <div class="text-right">
                                                <span class="text-[11px] font-black text-primary">{{ lot.currentQuantity }} {{ product?.unitOfMeasure }}</span>
                                                <p class="text-[8px] font-black uppercase text-emerald-500">Disp.</p>
                                            </div>
                                        </div>
                                    </button>
                                }
                            </div>
                        }
                    </div>

                    @if (selectedLot()) {
                        <div class="mt-2 pt-2 border-t border-slate-200 dark:border-slate-700 flex items-center justify-between">
                            <div class="flex items-center gap-1.5">
                                <iconify-icon icon="solar:check-circle-bold" class="text-emerald-500"></iconify-icon>
                                <span class="text-[10px] font-black uppercase text-slate-500">Lote seleccionado</span>
                            </div>
                            <button (click)="onLotSelect(null)" class="text-[9px] font-black uppercase text-rose-500 hover:underline">Cambiar</button>
                        </div>
                    }
                }
            </div>
        }

        <!-- Cantidad -->
        <div class="flex flex-col gap-1">
            <app-input label="Cantidad" type="number" [ngModel]="quantity()" (ngModelChange)="quantity.set($event)"
                icon="mdi:numeric" [placeholder]="type() === 'ADJUSTMENT' ? 'Nuevo stock físico' : 'Ingresa cantidad'">
            </app-input>
            @if (selectedLot() && type() === 'OUT' && quantity() > selectedLot().currentQuantity) {
                <span class="text-[10px] font-bold text-rose-500 bg-rose-50 px-2 py-1 rounded-lg border border-rose-100 flex items-center gap-1">
                    <iconify-icon icon="mdi:alert-circle"></iconify-icon>
                    Atención: La salida supera el stock actual de este lote.
                </span>
            }
        </div>

        <!-- Notas -->
        <div>
            <app-input label="Notas / Justificación" type="text" [ngModel]="notes()" (ngModelChange)="notes.set($event)"
                icon="mdi:note-text" placeholder="Describe el motivo del movimiento..." cl>
            </app-input>
        </div>
    </div>

    <!-- Acciones -->
    <div class="flex items-center gap-3 pt-4 border-t border-foreground/[0.05]">
        <app-button variant="glass" color="text-slate-500" class="flex-1" (btnClick)="close()">Cancelar</app-button>
        <app-button variant="primary" class="flex-1" (btnClick)="save()" [loading]="loading()">
            Confirmar {{ type() === 'IN' ? 'Entrada' : type() === 'OUT' ? 'Salida' : 'Ajuste' }}
        </app-button>
    </div>
</div>